import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { InlineCode } from '../components/blocks/InlineCode';

export const isInlineCode = isElementType(InlineCode);
